var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whatsapp"},[_c('a',{staticClass:"gtm-chats gtm-whatsapp whatsapp__btn",class:{ 
            'medium-bottom': _vm.$route.name === 'order.details', 
            'max-bottom': ['shopping-cart','contact-payment'].indexOf(_vm.$route.name) > -1
        },attrs:{"target":"__blank","rel":"noopener","href":_vm.whatsAppUrl}},[_c('img',{attrs:{"src":require("@/assets/whatsapp.svg"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }